var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.25C6.86193 5.25 6.75 5.13807 6.75 5V2H13.25V5C13.25 5.13807 13.1381 5.25 13 5.25H7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2H5.25V5C5.25 5.9665 6.0335 6.75 7 6.75H13C13.9665 6.75 14.75 5.9665 14.75 5V2H15.1716C15.702 2 16.2107 2.21071 16.5858 2.58579L20.4142 6.41421C20.7893 6.78929 21 7.29799 21 7.82843V20C21 21.1046 20.1046 22 19 22H16.75V17C16.75 16.0335 15.9665 15.25 15 15.25H9C8.0335 15.25 7.25 16.0335 7.25 17V22H5C3.89543 22 3 21.1046 3 20V4C3 2.89543 3.89543 2 5 2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 22H15.25V17C15.25 16.8619 15.1381 16.75 15 16.75H9C8.86193 16.75 8.75 16.8619 8.75 17V22ZM10.5 18.75H13.5C13.9142 18.75 14.25 19.0858 14.25 19.5C14.25 19.9142 13.9142 20.25 13.5 20.25H10.5C10.0858 20.25 9.75 19.9142 9.75 19.5C9.75 19.0858 10.0858 18.75 10.5 18.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.567fb923f12da90282bfe48bde2f7445.svg";
export { ForwardRef as ReactComponent };